// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"f4cc5956","293":"9df480c4","310":"23cbad1c","348":"d5dc6fc0","547":"ce63846f","787":"c887ae0d","889":"82f6509a","968":"6b6e7bdf","973":"67f23e01"}[chunkId] + ".chunk.js";
};